import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { User } from '@models/user.model';
import { SKIP, custom, deserialize, serializable } from 'serializr';
import { ExecutionConfigCondition } from './test-plan-execution-config-condition.enum';
import { ExecutionConfigType } from './test-plan-execution-config-type.enum';
import { FilterQuery } from '@models/filter-query.model';

export class ExecutionConfig extends Base implements PageObject {
  @serializable
  public name: string;

  @serializable(
    custom(
      (v) => JSON.stringify(v),
      (v) => {
        const filter: FilterQuery[] = [];
        v = Array.isArray(v) ? v : JSON.parse(v);
        v.forEach((query) => {
          filter.push(new FilterQuery().deserialize(query));
        });
        return filter;
      },
    ),
  )
  public query: FilterQuery[];

  @serializable
  public testPlanConfigCondition: ExecutionConfigCondition;

  @serializable
  public testPlanConfigType: ExecutionConfigType;

  @serializable
  public executionId: number;

  @serializable(
    custom(
      () => SKIP,
      (v) => new User().deserialize(v),
    ),
  )
  public createdByUser: User;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ExecutionConfig, input));
  }
}
